import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../../public/onboarding/services/user.service';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class AppAuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override router: Router,
    protected userService: UserService,
    protected keycloakService: KeycloakService
  ) {
    super(router, keycloakService);
  }

  isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (!this.authenticated) {
        this.userService.clearCachedUserProfile();
        this.keycloakService.login({ redirectUri: environment.feUrl });
        return resolve(true);
      }

      console.log(
        'roles ===== ' +
          this.keycloakService.getUserRoles() +
          ' === ' +
          route.toString() +
          ' ===== ' +
          route.url
      );

      // @ts-ignore
      const requiredRoles = route.data.roles;

      if (!requiredRoles || requiredRoles.length === 0) {
        return resolve(true);
      } else {
        if (!this.roles || this.roles.length === 0) {
          resolve(false);
        }
        let granted = false;
        for (const requiredRole of requiredRoles) {
          if (this.roles.indexOf(requiredRole) > -1) {
            granted = true;
            break;
          }
        }
        resolve(true);
      }
    });
  }
}
